import { Component, createRef } from "preact";
import actions from "../../actions";
import { getAdvancedDatePicker } from "../../../common/asyncComponents/DatePicker";
import IconCalendar from "../../../common/components/icons/IconCalendar";
import { connectWithTranslations } from "../../../common/helpers/translationsHelpers";
import IconCaretDown from "../../../common/components/icons/IconCaretDown";
import { TIME_FILTERS_VALUES } from "../../constants";
import { getDateRange } from "../../helpers/formatDate";

class DatePickerFilterDesktop extends Component {
    picker = createRef();

    constructor(props) {
        super(props);

        this.state = {
            datePicker: null,
            isOpen: false,
        };

        this.togglePicker = this.togglePicker.bind(this);
        this.resetDatePicker = this.resetDatePicker.bind(this);
        this.onApply = this.onApply.bind(this);
        this.changeRangeOption = this.changeRangeOption.bind(this);
        this.renderButton = this.renderButton.bind(this);
    }

    async togglePicker() {
        const { isOpen } = this.state;
        if (isOpen) {
            document.removeEventListener("click", this.handleOutsideClick, false);
            this.resetDatePicker();
            this.setState({ isOpen: false });
        } else {
            const picker = await getAdvancedDatePicker();
            this.setState({ datePicker: picker, isOpen: true });
            document.addEventListener("click", this.handleOutsideClick, false);
        }
    }

    handleOutsideClick = (e) => {
        let currentPicker = this.picker;
        if (currentPicker.current != null) {
            try {
                let containsWrapper = currentPicker.current.contains(e.target);
                let containsContainer = e.path?.indexOf(currentPicker.current) !== -1;
                if (!containsWrapper && !containsContainer) {
                    this.togglePicker();
                }
            } catch (error) {
                console.log(error);
            }
        }
    };

    resetDatePicker() {
        this.setState({ datePicker: undefined });
    }

    onApply(dateRange) {
        if (dateRange && dateRange.from && dateRange.to)
            this.props.applyFilter(dateRange);

        this.resetDatePicker();
    }

    async changeRangeOption(value) {
        this.props.onTimeFilterChanged(value);

        this.resetDatePicker();

        const picker = await getAdvancedDatePicker();
        this.setState({ datePicker: picker });
    }

    renderButton(
        value,
        getContentGtmId,
        getContentGa4Id,
        getGa4Name,
        showHighlighted,
        time,
        translate
    ) {
        return (
            <button
                type="button"
                data-gtmid={getContentGtmId && getContentGtmId(value)}
                data-ga4event-clk-name={getGa4Name && getGa4Name}
                data-ga4event-element={getContentGa4Id && getContentGa4Id(value)}
                class={
                    showHighlighted && time === value
                        ? "fxs_c_datepicker_button fxs_c_datepicker_button_active"
                        : "fxs_c_datepicker_button"
                }
                onClick={() => this.changeRangeOption(value)}
            >
                <span>
                    <span>{translate(value)}</span>
                </span>
            </button>
        );
    }

    render(
        {
            translate,
            config: { culture },
            dateRange,
            onDateRangeFilterChanged,
            onChangeCustomFilter,
            getButtonGtmId,
            getButtonGa4Id,
            getContentGtmId,
            getContentGa4Id,
            getGa4Name,
            showHighlighted,
            time,
        },
        { datePicker, isOpen }
    ) {
        return (
            <div class="fxs_c_datepicker-wrapper" ref={this.picker}>
                <button
                    type="button"
                    onClick={this.togglePicker}
                    class={`fxs_btn fxs_c_datepicker_trigger_button fxs_btn_xsmall ${
                        datePicker ? "fxs_c_datePicker_active" : ""
                    }`}
                    data-gtmid={getButtonGtmId}
                    data-ga4event-clk-name={getGa4Name}
                    data-ga4event-element={getButtonGa4Id}
                >
                    <IconCalendar />
                    <span> {getDateRange(dateRange, this.props.config.culture)} </span>
                    <IconCaretDown />
                </button>
                {isOpen && datePicker && (
                    <div class="fxs_c_DatePicker-Container">
                        <div class="fxs_c_datepicker_button_area">
                            {this.renderButton(
                                TIME_FILTERS_VALUES.RecentNext,
                                getContentGtmId,
                                getContentGa4Id,
                                getGa4Name,
                                showHighlighted,
                                time,
                                translate
                            )}
                            {this.renderButton(
                                TIME_FILTERS_VALUES.Today,
                                getContentGtmId,
                                getContentGa4Id,
                                getGa4Name,
                                showHighlighted,
                                time,
                                translate
                            )}

                            <hr class="fxs_c_datePicker_button_divider" />

                            {this.renderButton(
                                TIME_FILTERS_VALUES.Tomorrow,
                                getContentGtmId,
                                getContentGa4Id,
                                getGa4Name,
                                showHighlighted,
                                time,
                                translate
                            )}
                            {this.renderButton(
                                TIME_FILTERS_VALUES.Yesterday,
                                getContentGtmId,
                                getContentGa4Id,
                                getGa4Name,
                                showHighlighted,
                                time,
                                translate
                            )}

                            <hr class="fxs_c_datePicker_button_divider" />

                            {this.renderButton(
                                TIME_FILTERS_VALUES.ThisWeek,
                                getContentGtmId,
                                getContentGa4Id,
                                getGa4Name,
                                showHighlighted,
                                time,
                                translate
                            )}
                            {this.renderButton(
                                TIME_FILTERS_VALUES.ThisMonth,
                                getContentGtmId,
                                getContentGa4Id,
                                getGa4Name,
                                showHighlighted,
                                time,
                                translate
                            )}
                            {this.renderButton(
                                TIME_FILTERS_VALUES.NextWeek,
                                getContentGtmId,
                                getContentGa4Id,
                                getGa4Name,
                                showHighlighted,
                                time,
                                translate
                            )}
                            {this.renderButton(
                                TIME_FILTERS_VALUES.NextMonth,
                                getContentGtmId,
                                getContentGa4Id,
                                getGa4Name,
                                showHighlighted,
                                time,
                                translate
                            )}
                            {this.renderButton(
                                TIME_FILTERS_VALUES.PreviousWeek,
                                getContentGtmId,
                                getContentGa4Id,
                                getGa4Name,
                                showHighlighted,
                                time,
                                translate
                            )}
                            {this.renderButton(
                                TIME_FILTERS_VALUES.PreviousMonth,
                                getContentGtmId,
                                getContentGa4Id,
                                getGa4Name,
                                showHighlighted,
                                time,
                                translate
                            )}

                            <hr class="fxs_c_datePicker_button_divider" />

                            {this.renderButton(
                                TIME_FILTERS_VALUES.Custom,
                                getContentGtmId,
                                getContentGa4Id,
                                getGa4Name,
                                showHighlighted,
                                time,
                                translate
                            )}
                        </div>
                        <datePicker.default
                            className="fxs_c_DatePicker"
                            onApply={this.onApply}
                            applyLabel={translate("DateSelectorApply")}
                            dateRange={dateRange}
                            locale={culture}
                            onDateRangeFilterChanged={onDateRangeFilterChanged}
                            onChangeCustomFilter={onChangeCustomFilter}
                        />
                    </div>
                )}
            </div>
        );
    }
}

export default connectWithTranslations("config", actions)(DatePickerFilterDesktop);
